var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStorkLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.9835 0C29.0976 0 0 29.105 0 65C0 65 0.0329531 66.6316 0.0659062 67.4556C0.0659062 67.4556 16.5425 68.7246 22.507 69.4333C28.0596 70.109 33.9417 71.1803 37.9949 75.0368C40.5653 77.5089 42.0976 80.838 43.6958 84.0188C45.294 87.216 47.1229 90.4463 50.0558 92.4734C52.9886 94.484 57.3549 94.8796 59.9417 92.4404C63.2535 89.3256 61.9518 83.5408 58.8378 80.2282C55.7237 76.9156 52.0824 74.3775 48.4246 71.6747C38.1103 64.0606 33.6616 50.6782 38.0608 38.6473C38.7364 36.8015 39.5932 35.2028 40.5653 33.7855C38.6046 35.2193 34.3536 38.944 31.256 46.0142C33.5957 31.7089 48.507 26.2044 51.6705 25.8418C55.1635 24.8035 58.7554 24.5893 61.8365 24.9189C70.5526 25.8583 79.6971 29.8631 81.526 38.4495C91.2142 42.3884 109.058 47.7447 125.568 57.2541C111.118 54.8644 92.8783 48.4369 78.4284 45.6681C69.9594 44.0365 63.3359 43.0642 58.0634 46.5251C55.2953 48.3545 52.4284 52.2769 55.3447 56.9574C59.2826 63.286 65 65.7252 71.7883 71.889C76.0228 75.729 79.1039 81.0028 80.2243 86.6062C81.7731 94.3522 78.4943 102.296 74.3422 108.987C66.4829 121.628 56.0697 129.374 56.0697 129.374C59.0025 129.786 61.9848 130 65.0165 130C100.902 130 130 100.895 130 65C130 29.105 100.886 0 64.9835 0Z",
    fill: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 130,
    rx: 65,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorkLogo);
export default __webpack_public_path__ + "static/media/stork_logo.f8b51e0d3984c8d7f7a868aae60e9d9d.svg";
export { ForwardRef as ReactComponent };